// need to move this js to util directory

const contractMode = {
  CREATE_CONTRACT: 'CREATE_CONTRACT',
  FLOW: 'FLOW', // enum: 0
  QUICK_SIGN: 'QUICK_SIGN', // enum: 1
  COPY: 'COPY', // enum: 2
  API: 'API', // enum: 3
  VIDEO_PROPOSAL: 'VIDEO_PROPOSAL', // enum: 4
};

const fieldType = {
  SIGNATURE: 'SIGNATURE',
  FREE_TEXT: 'FREE_TEXT',
  DATE: 'DATE',
  CHECK_BOX: 'CHECK_BOX',
  NAME: 'NAME',
};

const roleType = {
  APPROVER_ROLE: 'APPROVER_ROLE',
  SIGNER_ROLE: 'SIGNER_ROLE',
  RECEIVER_ROLE: 'RECEIVER_ROLE',
  SEND_ONLY: 'SEND_ONLY',
};

const signType = {
  TURN_KEY: 'TURN_KEY',
  SCRAWL: 'SCRAWL',
};

const modalType = {
  DECLINE: 'DECLINE',
  CHANGE_REQUEST: 'CHANGE_REQUEST',
  SIGNATURE: 'SIGNATURE',
  WITHDRAW: 'WITHDRAW',
  ADD_CONTACT: 'ADD_CONTACT',
  EDIT_CONTACT: 'EDIT_CONTACT',
  MOBILE_DASHBOARD_ACTION: 'MOBILE_DASHBOARD_ACTION',
  MOBILE_ACC_SETTINGS: 'MOBILE_ACC_SETTINGS',
  ANIMATION_MODAL: 'ANIMATION_MODAL',
  VIDEO_RECORDER: 'VIDEO_RECORDER',
  VIDEO_OPTIONS: 'VIDEO_OPTIONS',
  VIDEO_REUSE: 'VIDEO_REUSE',
  VIDEO_UPLOAD: 'VIDEO_UPLOAD',
  ATTACH_FILES: 'ATTACH_FILES',
  ONBOARDING: 'ONBOARDING',
};

// the contract status is named contractState in backend
const contractState = {
  DRAFT: 'DRAFT',
  OUT_FOR_SIGNING: 'OUT_FOR_SIGNING',
  PARTLY_SIGNED: 'PARTLY_SIGNED',
  COMPLETED: 'COMPLETED',
  WITHDRAWN: 'WITHDRAWN',
  REJECTED: 'REJECTED',
  ARCHIVED: 'ARCHIVED',
};

const fieldDefaultValue = {
  defSigHeight: 75,
  defSigWidth: 175,
  defTextHeight: 30,
  defTextWidth: 200,
  defHeight: 30,
  defWidth: 200,
  defCheckHeight: 24,
  defCheckWidth: 24,
};

const qsUserBoxState = {
  ASSIGNED_FIELD_OPTIONS: 'ASSIGNED_FIELD_OPTIONS',
  PARTICIPANT_SELECTOR: 'PARTICIPANT_SELECTOR',
  CREATE_CONTACT: 'CREATE_CONTACT',
  NAME_OPTION: 'NAME_OPTION',
  TEXT_AREA_OPTION: 'TEXT_AREA_OPTION',
  CHECK_BOX_OPTION: 'CHECK_BOX_OPTION',
  DATE_OPTION: 'DATE_OPTION',
};

const modalState = {
  CLOSED: 'CLOSED',
  NAME_CONTRACT: 'NAME_CONTRACT',
  FINALIZED_FORM: 'FINALIZED_FORM',
  LANGUAGE_SELECTOR: 'LANGUAGE_SELECTOR',
  NAME_DOCUMENT: 'NAME_DOCUMENT',
};

const documentDiv = {
  defaultWidth: 796,
};

const languageMap = {
  uk: 'en-GB',
  dk: 'da-DK',
  es: 'es-ES',
  // se: 'sv-SE',
  nl: 'nl-NL',
  de: 'de-DE',
  fr: 'fr-FR',
  // it: 'it-IT',
};

const regMethod = {
  EMAIL: 'EMAIL',
  GOOGLE: 'GOOGLE',
  LINKEDIN: 'LINKEDIN',
  FACEBOOK: 'FACEBOOK',
  PROCESS_INVITE: 'INVITE_TO_PARTICIPATE',
  ACCORDIUM_MANAGEMENT_APP: 'ACCORDIUM_MANAGEMENT_APP',
};

const flowViewState = {
  CLOSED: 'CLOSED',
  SHOW_FLOW_VIEW: 'SHOW_FLOW_VIEW',
  SHOW_TRACKER_VIEW: 'SHOW_TRACKER_VIEW',
};

const flowViewSvg = {
  roleVerticalGap: 40,
  roleWidth: 260,
  roundRadius: 20,
  strokeMiddle: 6,
};

const flowAuditActions = [
  'ContractInitiatedEvent',
  'RoleInitiatedEvent',
  'UserInviteViewedEvent',
  'UserViewedEvent',
  'VideoViewedEvent',
  'UserSignedEvent',
  'UserApprovedEvent',
  'UserRejectedEvent',
  'ContractWithdrawnEvent',
];

const archiveType = {
  CONTRACT_ARCHIVE: 'contract-archive',
  DOCUMENT_ARCHIVE: 'document-archive',
};

export {
  contractMode,
  fieldType,
  roleType,
  signType,
  modalType,
  contractState,
  documentDiv,
  languageMap,
  regMethod,
  flowViewState,
  flowViewSvg,
  flowAuditActions,
  archiveType,
  fieldDefaultValue,
  qsUserBoxState,
  modalState,
};
